module.exports = __webpack_public_path__ + "static/Lato-Italic-7582e823ef0d702969ea0cce9afb326d.ttf";